export default "__VITE_ASSET__9582d12a__$_?nuxt_component=async&nuxt_component_name=SvgoStorytelling__"